import * as React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Create, FormManager, PageTitle, selectUser, UserState } from 'gossamer-front-end';
import { getListRowLink } from 'gossamer-unified';
import { AbsencePeriod } from 'cb-model';
import { useSelector } from 'react-redux';
import { CustomInfo } from 'cb-unified';

export const AbsencePeriodCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  const user = useSelector((state: { user: UserState }) => selectUser(state));
  const [searchParams] = useSearchParams();
  const institutionGroupId = searchParams.get('institution_group_id');

  return (
    <>
      <PageTitle verb="Create" entity={AbsencePeriod} />
      {user.userId && (
        <FormManager
          compoundUrl="/main/~/absence-period-create"
          handleCancel={() => navigate(`/admin/absence-period/search`)}
          handleSuccess={({ keyOfFirstCreate }) =>
            navigate(getListRowLink(AbsencePeriod.listRowLink, keyOfFirstCreate))
          }
          initialization={{
            main: {
              type: 'create-single',
              entity: AbsencePeriod,
              override: {
                institution_id: (user.customInfo as CustomInfo)?.adminInstitutionId,
                ...(institutionGroupId ? { institution_group_id: parseInt(institutionGroupId) } : {}),
              },
            },
          }}
        >
          <Create valuesKey="main" entity={AbsencePeriod} />
        </FormManager>
      )}
    </>
  );
};
